import React from 'react';
import {Row, Col} from 'antd';
import './Benefiter.css';
import bman from '../../Assests/assets/images/roland.png';
import student from '../../Assests/assets/images/student.png';
import student1 from '../../Assests/assets/images/1.png';
import entrepreneur from '../../Assests/assets/images/entrepreneur.png';
import professional from '../../Assests/assets/images/professional.png';
import check from '../../Assests/assets/images/icons-8-checkmark-5-copy-4.png';

const Benefiter = (props) => {
  return (
    <Row className='benefiter'>
      <Col lg={11}>
        <div class='benefiter-left'>
          <div class='benefiter-title-container'>
            <span class='benefiter-title'>
              Who will benefit from the course?
            </span>
          </div>
          <div class='benefiter-content'>
            <span class='benefiter-content-title'>
              Students from any stream aspiring to:
            </span>
            <span class='benefiter-content-pt'>
              <div class='benefiter-content-icon'>
                <img src={check}/>
              </div>
              do MBA Finance
            </span>
            <span class='benefiter-content-pt'>
              <div class='benefiter-content-icon'>
                <img src={check}/>
              </div>
              be an entrepreneur
            </span>
            <span class='benefiter-content-pt'>
              <div class='benefiter-content-icon'>
                <img src={check}/>
              </div>
              be a CEO, CFO, Director etc
            </span>
            <span class='benefiter-content-pt'>
              <div class='benefiter-content-icon'>
                <img src={check}/>
              </div>
              be a professional (in the field of finance, tax, 
              accounting and management consulting)
            </span>
          </div>
        </div>
      </Col>
      <Col lg={13}>
        <div class='benefiter-right'>
          <div class='benefiter-imgs'>
            <Row>
              <Col xs={12} sm={12} md={12}>
                <span class='benefiter-img-container'>
                  <img src={student1} class='benefiter-img'/>
                </span>
              </Col>
              <Col xs={12} sm={12} md={12}>
                <span class='benefiter-img-container'>
                  <img src={student} class='benefiter-img'/>
                </span>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12} md={12}>
                <span class='benefiter-img-container'>
                  <img src={professional} class='benefiter-img'/>
                </span>
              </Col>
              <Col xs= {12} sm={12} md={12}>
                <span class='benefiter-img-container'>
                  <img src={entrepreneur} class='benefiter-img'/>
                </span>
              </Col>
            </Row>
          </div>
        </div>
      </Col>
    </Row>
  )
}
export default Benefiter;
